// import React, { useEffect, useRef } from "react";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import Button from "../../component/ui/Button";

// gsap.registerPlugin(ScrollTrigger);

// const CallToActionSection = () => {
//   const sectionRef = useRef(null);

//   useEffect(() => {
//     const context = gsap.context(() => {
//       const textElements = gsap.utils.toArray(
//         sectionRef.current.querySelectorAll(".animated-text-content")
//       );

//       textElements.forEach((element, index) => {
//         // Set Initial State: Hidden, down, and clipped
//         gsap.set(element, {
//           y: 25,
//           opacity: 0,
//           clipPath: "inset(100% 0 0% 0)",
//         });

//         // Animation Timeline
//         gsap.to(element, {
//           y: 0, // Move to original position
//           opacity: 1, // Become visible
//           clipPath: "inset(0% 0 0% 0)", // Unclip
//           duration: 1,
//           ease: "power2.out",
//           delay: index * 0.1, // Stagger the animation slightly for each element
//           scrollTrigger: {
//             trigger: element.closest(".cta-container"), // Trigger based on the main container
//             start: "top 85%",
//             end: "center 60%",
//             scrub: 1,
//           },
//         });
//       });
//     }, sectionRef);

//     return () => context.revert();
//   }, []);

//   return (
//     <section
//       ref={sectionRef}
//       className="w-full my-[40px] 2xl:my-[80px] font-[Sora]"
//     >
//       <div className="max-w-[1612px] mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="flex flex-row justify-center items-center w-full">
//           {/* Added 'cta-container' class for the ScrollTrigger target */}
//           <div className="bg-[#9FC46D] rounded-[25px] 2xl:rounded-lg px-[27px] 2xl:px-[54px] py-[27px] 2xl:py-[54px] w-full cta-container">
//             <div className="flex flex-col gap-[10px] 2xl:gap-[20px] justify-start items-center w-full">
//               {/* 1. Heading */}
//               <h2 className="text-[20px] 2xl:text-[60px] font-bold text-center text-text-primary animated-text-content">
//                 Join Us in Creating a Greener Tomorrow
//               </h2>

//               {/* 2. Paragraph */}
//               <p className="text-[16px] 2xl:text-[24px] font-normal text-center text-text-primary w-full lg:w-3/4 animated-text-content">
//                 At Govardhannathji Energies LLP, we believe that every step
//                 toward sustainability counts. Whether you are a farmer looking
//                 to improve soil health, an industry aiming to reduce energy
//                 costs, or an advocate for eco-friendly solutions, we are here to
//                 support your journey.
//               </p>

//               {/* 3. Button Wrapper */}
//               {/* Wrapped in a div with animated-text-content to handle the clip-path cleanly */}
//               <div className="animated-text-content">
//                 <Button
//                   text="Learn More"
//                   text_font_size="16"
//                   text_font_family="Sora"
//                   text_font_weight="700"
//                   text_line_height="20px"
//                   text_text_align="center"
//                   text_color="white"
//                   fill_background_color="#1C233A"
//                   border_border_radius="30px"
//                   border_border="none"
//                   padding="6px 17px"
//                   className="w-auto text-[16px] sm:text-[20px] 2xl:text-[24px] leading-[20px] sm:leading-[25px] 2xl:leading-[31px] py-[6px] px-[17px] sm:py-[9px] sm:px-[25px] 2xl:py-[12px] 2xl:px-[34px]"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CallToActionSection;

import React from "react";
import CommonCTA from "../../component/common/CommonCTA";

const CallToActionSection = () => {
  // Define specific button styles if needed, or leave empty to use defaults
  const handleLearnMore = () => {
    console.log("Navigate to learn more");
  };

  return (
    <div className="my-[40px] 2xl:my-[80px] ">
      {/* 1. The Original Section (Recreated) */}
      <CommonCTA
        heading="Join Us in Creating a Greener Tomorrow"
        description="Be a part of our mission to turn waste into powerful resources. Whether you're a farmer seeking healthier soil, a business pursuing clean energy, or a community focused on environmental responsibility -  Govardhannathji Energies LLP is here to support your sustainable journey."
        buttonText="Learn More"
        backgroundColor="#9FC46D"
        buttonProps={{
          onClick: handleLearnMore,
          // You can override colors here if needed
          fill_background_color: "#1C233A",
        }}
      />
    </div>
  );
};

export default CallToActionSection;
